export default [
  {
    path: "/master-data-siswa/siswa-list",
    name: "siswa-list",
    meta: { title: "Daftar Siswa", authRequired: true },
    component: () => import("../views/siswa/siswa-list")
  },
  {
    path: "/master-data-siswa/siswa-details",
    name: "siswa-add",
    meta: { title: "Tambah Siswa", authRequired: true },
    component: () => import("../views/siswa/siswa-details")
  },
  {
    path: "/master-data-siswa/siswa-details/:id",
    name: "siswa-view",
    meta: { title: "Detail Siswa", authRequired: true },
    component: () => import("../views/siswa/siswa-details")
  },
]
